<!--
================================================
Un loader qui s'affiche le temps que l'application soit chargée
Url d'accès : http://localhost:8080/fr/cronocloud-inc/user/settings
================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <div id="PageLoaderComp">

        <div class="columns is-vcentered loaderContainer">
            <div class="column">

                <div class="spinnerContainer">
                    <spinner-loader-comp></spinner-loader-comp>

                </div>
                <p>{{$t('chargementEnCours...')}}</p>

                <img src="../assets/img/AppLogo.png" alt="logo" width="">

            </div>
        </div>

    </div>
</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    import {mapState} from 'vuex'
    // import SentryMixin from "../mixins/SentryMixin.js";
    import SpinnerLoaderComp from "./SpinnerLoaderComp.vue";


    export default {
        name: 'PageLoaderComp',
        // mixins: [GlobalErrorNotification, SentryMixin],
        components: {
            SpinnerLoaderComp

        },
        data: function () {
            return {
            }
        },
        computed:{
            // computed props for store :
            ...mapState({
                appIsLoading: state => state.app.isLoading
            }),

        },


        methods: {

        },

        // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
        mounted: function () {
        }
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../assets/css/globalVar.scss";
    /*@import "../assets/css/bulmaResponsiveDep.scss";*/


    .loaderContainer{
        background: #f4f4f4;
        min-height: 100vh;

        p {
            color: #777;
        }
        img{
            margin: 1rem 0;
            width: 180px ;
        }
    }
</style>
